const { defineMessages } = require('@sm/intl');

const COPY = defineMessages({
  ALWAYS_FREE: {
    id: 'Pricing.AlwaysFreeByline',
    defaultMessage: 'Always free',
    desc: '[Type: Text][Vis: high] - Always free byline',
  },
  PER_MONTH: {
    id: 'Pricing.PricePerMonthByline',
    defaultMessage: '/ month',
    desc: '[Type: Text][Vis: high] - Price per month byline',
  },
  PER_USER_PER_MONTH: {
    id: 'Pricing.PricePerUserPerMonthByline',
    defaultMessage: '/ user / month',
    desc: '[Type: Text][Vis: high] - Price per user per month byline',
  },
  BILLED_ANNUALLY: {
    id: 'Pricing.PerMonthAnnuallyByline',
    defaultMessage: `{price} billed annually`,
    desc: '[Type: Text][Vis: high] - Price per month billed annually byline',
  },
  TEAMS_BILLED_ANNUALLY: {
    id: 'Pricing.PriceBilledAnnuallyByline',
    defaultMessage: 'Starting at 3 users, billed annually',
    desc: '[Type: Text][Vis: high] - Price billed annually byline',
  },
  // individual country overrides. to override, prefix `BILLED_ANNUALLY` or `TEAMS_BILLED_ANNUALLY` with the country code
  BR_BILLED_ANNUALLY: {
    id: 'Pricing.BrazilBilledAnnually',
    defaultMessage: 'paid annually (up front)',
    desc: '[Type: Text][Vis: high] - Brazil billed annually byline',
  },
  BR_TEAMS_BILLED_ANNUALLY: {
    id: 'Pricing.BrazilTeamsBilledAnnually',
    defaultMessage: 'paid annually for 3 users (up front)',
    desc: '[Type: Text][Vis: high] - Brazil teams billed annually byline',
  },
  ENT_PLATINUM_BYLINE: {
    id: 'Pricing.EnterpriseByline',
    defaultMessage: 'Powerful admin tools, integrations, and collaboration features for your organization.',
    desc: '[Type: Text][Vis: high] - Enterprise pricing byline',
  },
});

export default COPY;
